import aiIcon from "../../webroot/images/ai.png";

const AiIcon = () => {
    return <img src={aiIcon} className="ai-img" alt="Fields filled by AI" />;
};

export default AiIcon;
